import React, { useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import Card from "./atoms/Card"
import data from "../yourdata"

const Work = () => {
  const [tab, setTab] = useState("web")

  // Map tabs to data keys for cleaner logic
  const projectMap = {
    mobile: data.mobileProjects,
    web: data.webProjects,
    blockchain: data.blockchain,
  }

  const activeProjects = projectMap[tab] || []

  return (
    <div className="section" id="work">
      <div className="container">
        <div className="work-wrapper">
          <h1>
            Featured Work
          </h1>

          {/* Modern Tab Switcher */}
          {/* <div className="tab-container">
            {["mobile", "web", "blockchain"].map((t) => (
              <button
                key={t}
                className={`tab-btn ${tab === t ? "active" : ""}`}
                onClick={() => setTab(t)}
              >
                {t.charAt(0).toUpperCase() + t.slice(1)}
                {tab === t && (
                  <motion.div 
                    layoutId="activeTab" 
                    className="active-indicator" 
                  />
                )}
              </button>
            ))}
          </div> */}

          {/* Animated Project Grid */}
          <motion.div layout className="grid">
            <AnimatePresence mode="popLayout">
              {activeProjects.map((project, index) => (
                <motion.div
                  key={project.title} // Use unique title for layout morphing
                  layout
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.9 }}
                  transition={{ duration: 0.4, delay: index * 0.05 }}
                >
                  <Card
                    heading={project.title}
                    paragraph={project.para}
                    imgUrl={project.imageSrc}
                    projectLink={project.url}
                    technology={project.technology}
                  />
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>
        </div>
      </div>
    </div>
  )
}

export default Work